import { useState, useEffect } from "react";
import { Button, Container, Grid, Stack, Typography, TextField, Chip, Checkbox, Select, OutlinedInput, MenuItem, useTheme, FormControl, FormControlLabel, FormLabel, RadioGroup, Radio, Paper } from "@mui/material";
// components
import axios from "axios";
import { alert } from "src/services/alert";
import FormItem from "src/components/form-item/FormItem";
import FormDialog from "src/components/common/FormDialog";
// ----------------------------------------------------------------------

export default function AddressPicker({ address, onChange }) {
  const [mapAction, setMapAction] = useState("");

  // const [form, setForm] = useState({
  //   name: info.name || "",
  //   address: info.address || "",
  //   city: info.city || "",
  //   lat: info.lat || "",
  //   lng: info.lng || "",
  //   poiname: info.poiname || "",
  //   remark: info.remark || "",
  // });

  useEffect(() => {
    window.addEventListener("message", handleMapEvent, false);

    return () => {
      window.removeEventListener("message", handleMapEvent, false);
    };
  }, [address]);

  function handleMapEvent(event) {
    console.log("event fired");
    // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
    const loc = event.data;
    if (loc && loc.module == "locationPicker") {
      //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
      console.log("location", loc);
      // setLoc(loc);
      // handleIptChange('address', loc.poiaddress);

      // setForm({
      //   ...form,
      //   address: loc.poiaddress,
      //   city: loc.cityname,
      //   lat: loc.latlng.lat,
      //   lng: loc.latlng.lng,
      //   poiname: loc.poiname,
      // });

      onChange({
        address: loc.poiaddress,
        city: loc.cityname,
        lat: loc.latlng.lat,
        lng: loc.latlng.lng,
        poiname: loc.poiname,
      });
    }
  }

  function handleDialogConfirm() {
    setMapAction("");
  }

  return (
    <>

      <FormItem title="地址" required>
        <TextField fullWidth placeholder="地址" autoComplete="off" id="address" value={address} size="small" 
        // onChange={(e) => handleIptChange("address", e.target.value)} 
        />

        <Button variant="contained" sx={{ whiteSpace: "noWrap" }} onClick={() => setMapAction("add")}>
          选择地址
        </Button>
      </FormItem>

      <FormDialog title={mapAction === "add" ? "添加地址" : "修改地址"} open={!!mapAction} onClose={() => setMapAction()} onConfirm={handleDialogConfirm}>
        <iframe
          id="mapPage"
          style={{
            width: "80vw",
            height: "80vh",
            zIndex: "1200",
            // position: "fixed",
            top: "10vh",
            left: "10vw",
            right: "0",
          }}
          frameBorder="0"
          src={`https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=C7VBZ-TF63V-BXHPU-53PLD-5IHCF-ZQBR7&referer=鲸世优选`}
        />
      </FormDialog>
    </>
  );
}
